export const GET_SYSTEM_ADMIN_PRODUCT_TYPE = 'getSystemAdminProductType';
export const UPDATE_SYSTEM_ADMIN_PRODUCT_TYPE = 'updateSystemAdminProductType';
export const ADD_SYSTEM_ADMIN_PRODUCT_TYPES = 'addSystemAdminProductTypes';
export const ADD_SYSTEM_ADMIN_PRODUCT_TYPE = 'addSystemAdminProductType';
export const DELETE_SYSTEM_ADMIN_PRODUCT_TYPE = 'deleteSystemAdminProductType';
